import { useEffect } from "react";

const SITE = "https://twojebiuro.waw.pl";
const BRAND = "Wirtualne Biuro Warszawa | Twoje Biuro";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) { el?.remove(); return; }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function useSeo({ title, description, path = "/", noindex = false, jsonLd = null, breadcrumbs = null }) {
  useEffect(() => {
    const fullTitle = !title ? BRAND : /wirtualne biuro/i.test(title) ? title : `${title} | Wirtualne Biuro Warszawa — Twoje Biuro`;
    document.title = fullTitle;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${SITE}${path}`;
    setJsonLd("ld-page", jsonLd);
    setJsonLd("ld-breadcrumbs", breadcrumbs ? {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [{ name: "Wirtualne biuro Warszawa", path: "/" }, ...breadcrumbs].map((b, i) => ({
        "@type": "ListItem", position: i + 1, name: b.name, item: `${SITE}${b.path}`,
      })),
    } : null);
  }, [title, description, path, noindex, jsonLd, breadcrumbs]);
}

export const SITE_URL = SITE;
